export var APOLLO_ERROR_LINK = 'apollo-error-link';
export var APOLLO_COMMERCE_CONTEXT = 'commerce';
export var ONEGRAPH_GRAPHQL_PATH = 'one-graph/graphql';
export var ONEGRAPH_URI_PROD = "https://gateway.chegg.com/".concat(ONEGRAPH_GRAPHQL_PATH);
export var ONEGRAPH_URI_TEST = "https://gateway.test.cheggnet.com/".concat(ONEGRAPH_GRAPHQL_PATH);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/constants.js
// module id = 228
// module chunks = 11